function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "label", "style"],
  _excluded2 = ["required", "label", "className", "vertical", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { pickBy } from "lodash-es";
import { useId } from "../../helpers/hooks";
import { Label } from "../label/Label";
export var RadioContext = /*#__PURE__*/React.createContext();
RadioContext.displayName = "RadioContext";

/**
 * removes unnecessary props
 */
function getContextProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _children = _ref.children,
    _label = _ref.label,
    _style = _ref.style,
    context = _objectWithoutProperties(_ref, _excluded);
  return context;
}
export function getInputProps(context, props) {
  var isChecked = props.checked;
  if (context) {
    isChecked = props.value === context.value;
  }
  var inputProps = _objectSpread(_objectSpread(_objectSpread({}, getContextProps(context)), pickBy(props, function (value) {
    return value !== undefined;
  })), {}, {
    checked: isChecked
  });
  return inputProps;
}
var RadioGroup = function RadioGroup(_ref2) {
  var _ref2$required = _ref2.required,
    required = _ref2$required === void 0 ? false : _ref2$required,
    label = _ref2.label,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? "" : _ref2$className,
    _ref2$vertical = _ref2.vertical,
    vertical = _ref2$vertical === void 0 ? false : _ref2$vertical,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var id = useId();
  var labelId = "tui-radio-group-".concat(id);
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, label && /*#__PURE__*/React.createElement(Label, {
    id: labelId,
    required: required
  }, label), /*#__PURE__*/React.createElement("div", {
    "aria-required": required,
    className: classNames("tui-radio-group", className, {
      vertical: vertical
    }),
    role: "radiogroup",
    "aria-labelledby": label ? labelId : null
  }, /*#__PURE__*/React.createElement(RadioContext.Provider, {
    value: props
  }, props.children)));
};
RadioGroup.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  label: PropTypes.node,
  required: PropTypes.bool,
  className: PropTypes.string,
  vertical: PropTypes.bool
};
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map